import { Usuario } from './../../../_core/models/usuario';
import { PageService } from './../../../_core/services/page.service';
import { CadastroBemService } from './../../../_core/services/cadastro-bem.service';
import { CadastroBem } from './../../../_core/models/cadastro-bem';
import { Page } from './../../../_core/models/page';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MeusBensModalComponent } from '../meus-bens-modal/meus-bens-modal.component';
import { SolicitacaoBensModalComponent } from '../../solicitar-bens';

@Component({
  selector: 'app-meus-bens',
  templateUrl: './meus-bens.component.html',
  styleUrls: ['./meus-bens.component.scss']
})
export class MeusBensComponent implements OnInit {
  user!:Usuario;
  pagina = 1;
  total = 10;
  page!: Page;
  ativo = true;
  pesquisa = '';
  loading = true;
  cadastroBens!: CadastroBem;
  constructor(
    private cadastroBensService:CadastroBemService,
    private pageService:PageService,
    private modalService:NgbModal) {
      this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
     }

  ngOnInit(): void {
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }
  setPage(page: number): void {
    this.loading = true;
    this.page.currentPage = page;
    //console.log/"==> " + JSON.stringify(this.page))
    this.cadastroBensService.getMeusBens(this.user.cD_MATRICULA,this.page)
      .subscribe(
        data => {
          this.page = data;
          this.page = this.pageService.getPager(this.page);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      )
  }
  paginaAtual(pagina:any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }
  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
  abreEdicao(nR_BPM_BEM_PATRIMONIAL:number){
    const modalRef = this.modalService.open(MeusBensModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
    modalRef.result.then(() => this.atualizar());
  }
  abreSolicitacao(nR_BPM_BEM_PATRIMONIAL:number){
    const modalRef = this.modalService.open(SolicitacaoBensModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
    modalRef.result.then(() => this.atualizar());
  }
}
